import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import ContentEditable from './content_editable';
import sanitizeContentEditableHtml from '../helpers/sanitize_content_editable_html';

const blockTagNames = ['div', 'td', 'th'];

class Text extends React.Component {
  static propTypes = {
    aiPromptKey: PropTypes.string,
    defaultHtml: PropTypes.string.isRequired,
    highlight: PropTypes.bool,
    override: PropTypes.string,
    renderHeader: PropTypes.func,
    sanitize: PropTypes.bool,
    parentTagName: PropTypes.string.isRequired,

    onAiInteraction: PropTypes.func,
    onOverrideChange: PropTypes.func.isRequired,
    onOverrideReset: PropTypes.func.isRequired
  }

  render() {
    const inline = blockTagNames.indexOf(this.props.parentTagName) === -1;
    const tagName = inline ? 'span' : 'div';

    return (
      <ContentEditable
        aiPromptKey={this.props.aiPromptKey}
        className={classNames('text-component', { inline })}
        contentEditableTagName={tagName}
        defaultHtml={this.props.defaultHtml}
        highlight={this.props.highlight}
        override={this.props.override}
        renderHeader={this.props.renderHeader}
        sanitizer={this.props.sanitize ? sanitizeContentEditableHtml : null}
        wrapperTagName={tagName}
        onAiInteraction={this.props.onAiInteraction}
        onOverrideChange={this.props.onOverrideChange}
        onOverrideReset={this.props.onOverrideReset}
      />
    );
  }
}

export default Text;
